<template>
    <!-- PC -->
    <div v-if="!mobile">
        <div>
            <div class="lkt-manual env_VN">
                <div>
                    <h1>修了試験</h1>
                    <p>※ 試験の途中にデバイスは変わったら、提出されていない問題の回答は保存されず、最初からやり直す必要があります。</p>
                </div>
                <div><img src="/static\images\ja\newManual\finalExamManual-1.png" alt="" /></div>
                <div>
                    <p>① 【修了試験】ボタンをクリックして、コースの修了試験が受けられます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\exam_final_new_1.png" alt="" /></div>
                <div>
                    <p>【修了試験】ボタンを押すと、以下の画面が表示されます。</p>
                    <p>※ 試験問題は「全て表示するか」又は「一問ずつ表示するか」を選択することができます。</p>
                    <p>② 【試験開始】ボタンを押すと試験が始まります。</p>
                </div>
                <div><img src="/static\images\ja\newManual\edit_exam_final_2.png" alt="" /></div>
                <div>
                    <p>③ 各試験問題に正しい答えを選択して答えてください。</p>
                    <p>④ 問題の答えがよくわからない場合は、【再確認】をチェックしてください。</p>
                    <p>⑤ 問題総数が表示されます。</p>
                    <p>&nbsp;&nbsp;&nbsp; 赤い枠線にて「何処まで回答しているか」を示しています。</p>
                    <p>&nbsp;&nbsp;&nbsp; 青色にて「回答済みの問題」を示しています。</p>
                    <p>⑥ 再確認必要の問題リストを表示します。</p>
                    <p>⑦ 【提出】ボタンをクリックすると、試験の回答結果を提出する確認メッセージが表示されます。</p>
                    <p>⑧ 【表示モード変更】ボタンで問題は「全て表示するか」又は「一問ずつ表示するか」を切替えることができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\edit_exam_final3.png" alt="" /></div>
                <div>
                    <p>【提出】ボタンを押すと、確認画面が表示されます。 確認画面に答えた問題数も確認できます。</p>
                    <p>⑨ 【OK】ボタンをクリックすると自動採点が始まります。</p>
                    <p>※ 提出したくない場合は、【X】または【キャンセル】ボタンを押してテスト画面に戻ることができます。</p>
                    <p>※ 制限時間を超過しても【OK】ボタンを押さなかった場合は、強制的に自動提出されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\edit_exam_final4.png" alt="" /></div>
                <div>
                    <p>【OK】をクリックすると、結果通知画面が表示されます。</p>
                    <p>⑩ 【不正解問題の詳細】ボタンをクリックと、間違った問題のリストが表示されます。</p>
                    <p>⑪ 【確認】ボタンを押すと授業の目次画面に戻ります。</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Mobile -->
    <div v-else>
        <div>
            <div class="lkt-manual env_VN">
                <div><p>① 【修了試験】をクリックします。</p></div>
                <div><p>※ コースの全てのコンテンツを学習完了していない場合、修了試験をクリックしても修了試験を受けることはできません。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\final_test_1_1.png" alt="" /></div>
                <div><img src="/static\images\ja\newManual\mobile\final_test_1_2.png" alt="" /></div>
                <div><p>※ コースのコンテンツが全て学習し（各章はすべて緑色になっていること）、修了試験をクリックすると、試験注意事項画面に遷移します。</p></div>
                <div><img src="/static\images\ja\newManual\mobile\final_test_1_3.png" alt="" /></div>
                <div><p>② 【試験開始】ボタンを押すと、修了試験が始まります。 【キャンセル】ボタンを押すと、コースの目次画面に戻ります。</p></div>
                <div><p>※ 修了試験は何度でも受けることができます。 合格/不合格の判断は、最終回の試験結果に基づいて行われます。</p></div>
                <div><p>● 表示形式：問題を「全て表示するか」、「一問ずつ表示するか」を選択することができます。</p></div>
                <div><p>● 受験回数：今まで受けた修了試験の総回数</p></div>
                <div><p>● 最近得点：前回の修了試験の得点</p></div>
                <div><p>● 最高得点：修了試験の最高得点</p></div>
                <div><img src="/static\images\ja\newManual\mobile\edit_exam_final_mb_1.png" alt="" /></div>
                <div>
                    <p>③ 【一覧】ボタンをクリックすると、回答した問題数と再確認問題リストが表示されます。</p>
                    <p>● 赤い枠線にて「何処まで回答しているか」を示しています。</p>
                    <p>● 青色にて「回答済みの問題」を示しています。</p>
                    <p>● 問題番号をクリックすると、その問題に遷移します。</p>
                    <p>④ 【提出】ボタンをクリックすると、試験の回答結果を提出する確認メッセージが表示されます。</p>
                    <p>⑤ 各試験問題に正しい答えを選択して答えてください。</p>
                    <p>⑥ 再確認必要の問題リストを表示します。</p>
                    <p>⑦ 問題は【前へ】または【次へ】で切り替えることができます。【表示モード変更】で「問題を全て表示するか、又は「一問ずつ表示するか」を切替えることができます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\edit_exam_final_mb_2.png" alt="" /></div>
                <div>
                    <p>【提出】ボタンを押すと、確認画面が表示されます。 確認画面に問題数も確認できます。</p>
                    <p>⑨ 【OK】ボタンをクリックすると自動採点が始まります。</p>
                    <p>※ 提出したくない場合は、【X】または【キャンセル】ボタンを押してテスト画面に戻ることができます。</p>
                    <p>※ 制限時間を超過しても【OK】ボタンを押さなかった場合は、強制的に自動提出されます。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\edit_exam_final_mb_3.png" alt="" /></div>
                <div>
                    <p>【OK】をクリックすると、結果通知画面が表示されます。</p>
                    <p>⑩ 【不正解問題の詳細】ボタンをクリックと、間違った問題のリストが表示されます。</p>
                    <p>⑪ 【確認】ボタンを押すとコースの目次画面に戻ります。</p>
                </div>
                <div><img src="/static\images\ja\newManual\mobile\edit_exam_final_mb_4.png" alt="" /></div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {};
        },
        components: {},
        computed: {
            mobile() {
                return this.$store.getters["header/mobile"];
            },
        },
        async created() {},
        watch: {},
        methods: {
            scrollToElement(id) {
                let element = document.getElementById(id);
                element.scrollIntoView();
            },
        },
    };
</script>
<style scoped>
    .lkt-manual div {
        margin-bottom: 10px;
    }
    .lkt-manual p {
        line-height: 25px;
    }
    .lkt-manual ul {
        margin-left: 20px;
        list-style: square;
        font-size: 12pt;
    }
    ul li {
        cursor: pointer;
    }
    img {
        width: 100%;
    }
    p {
        font-size: 16px;
    }
</style>



// WEBPACK FOOTER //
// src/components/manual/content/ja/finalExam_manual.vue